// Docs: https://bootstrap-vue.js.org/docs/misc/settings/#configuring-defaults

import Vue from 'vue';
import {
    BVConfigPlugin,
    NavPlugin,
    LinkPlugin,
    LayoutPlugin,
    ButtonPlugin,
    ProgressPlugin,
} from 'bootstrap-vue';

export default {
    init() {
        // Supply complete config to the BVConfigPlugin helper plugin.
        Vue.use(BVConfigPlugin, {
            breakpoints: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],
        });

        // Then use component plugins.
        Vue.use(NavPlugin);
        Vue.use(LinkPlugin);
        Vue.use(LayoutPlugin);
        Vue.use(ButtonPlugin);
        Vue.use(ProgressPlugin);
    },
};
